import { Component, OnInit } from '@angular/core';
import { MapAsideService } from '../../service/map-aside.service';

@Component({
  selector: 'app-not-found-content',
  templateUrl: './not-found-content.component.html',
  styleUrls: ['./not-found-content.component.scss'],
})
export class NotFoundContentComponent implements OnInit {
  constructor(private mapAsideService: MapAsideService) {}

  ngOnInit(): void {}

  closeMapAside() {
    this.mapAsideService.hide();
  }
}
